import { Blockquote, VocabularyFooter } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Blockquote,
  VocabularyFooter,
  React
};